import React from "react";

// Whole-radar empty state (design source, desktop + mobile). Concentric target
// rings with a blue dot, title, body, and the "Browse players" CTA.
const RadarEmptyState = ({ mobile = false, onBrowse }) => {
  const outer = mobile ? 60 : 64;
  const inner = mobile ? 34 : 38;
  const dot = mobile ? 9 : 10;
  return (
    <div
      className={mobile ? "mx-4 my-3" : ""}
      style={{
        background: "#FFFFFF",
        border: "1px solid #E4E9F0",
        borderRadius: 14,
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        padding: mobile ? "56px 22px" : "72px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        textAlign: "center",
      }}
    >
      <div
        className="flex items-center justify-center"
        style={{ width: outer, height: outer, borderRadius: "50%", border: "1.5px solid #DDE3EB", marginBottom: mobile ? 6 : 8 }}
      >
        <div
          className="flex items-center justify-center"
          style={{ width: inner, height: inner, borderRadius: "50%", border: "1.5px solid #C7D0DC" }}
        >
          <div style={{ width: dot, height: dot, borderRadius: "50%", background: "#2283FF" }} />
        </div>
      </div>
      <div className="text-[16px] font-bold text-[#111827]">Your radar is empty</div>
      <div className="text-[13px] text-[#6B7280] leading-[1.55]" style={{ maxWidth: 360 }}>
        Open any player&apos;s profile and tap <b className="text-[#374151]">Add to Radar</b>. Every player you save lands
        here{mobile ? "." : " — sort them into lists whenever you like."}
      </div>
      <button
        type="button"
        onClick={onBrowse}
        className="mt-3 bg-[#2283FF] hover:bg-[#1B6FE0] text-white border-none rounded-[9px] font-semibold cursor-pointer"
        style={mobile ? { height: 46, padding: "0 18px", fontSize: 14 } : { padding: "9px 16px", fontSize: 13 }}
      >
        Browse players
      </button>
    </div>
  );
};

export default RadarEmptyState;
